<div class="collection-card" [class.mobile]="deviceService.isMobile()"
     itemscope itemtype="https://schema.org/Product">

  <app-collection-meta [collection]="collection"></app-collection-meta>

  <ng-template [ngIf]="showSkeleton">
    <app-skeleton class="card-body" [class.mobile]="deviceService.isMobile()" [stats]="'collection'"></app-skeleton>
  </ng-template>

  <ng-container *ngIf="loadedUserInfo && !showSkeleton">
    <ng-container *ngTemplateOutlet="cardBody"></ng-container>
  </ng-container>

  <app-collection-review-form [collectionReview]="collection"></app-collection-review-form>

  <div class="content-cards" [class.responsive-scroll-viewport]="deviceService.isMobile()">
    <div *ngFor="let item of filteredItems; trackBy: trackByFn" class="card">
      <ng-template [ngIf]="item.content">
        <ng-template [ngIf]="isOpenedContent(item)"
                     [ngIfThen]="openedContentCardRef"
                     [ngIfElse]="closedContentCardRef">
        </ng-template>

        <ng-template #openedContentCardRef>
          <div (click)="onOpenCard(item)">
            <app-lesson [content]="item.content"></app-lesson>
          </div>
        </ng-template>

        <ng-template #closedContentCardRef>
          <div class="closed-content-card-wrap" (click)="showPaidContentModal(item)">
            <app-icon class="lock-icon" icon="lock"></app-icon>
            <app-lesson [content]="item.content"></app-lesson>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #cardBody>
  <app-status-badge *ngIf="isOnModeration || isDeclined"
                    [status]="collection.moderation_status"
                    [reason]="collection.moderation_message">
  </app-status-badge>
  <article class="card-body" [class.mobile]="deviceService.isMobile()">
    <div class="meta">
      <div class="type label">{{ 'collections.collection' | translate }}</div>
      <div class="cover-wrap">
        <ng-container *ngTemplateOutlet="coverBlock"></ng-container>
      </div>
      <div class="info-block">
        <i class="subject-wrap">
          <span class="subject">{{ subject }}</span>
          <ng-template [ngIf]="subjectIsNative">
            <span class="native normal">{{ 'library.user-service-card.native' | translate }}</span>
          </ng-template>
        </i>
        <a [routerLink]="collectionUrl" class="title-block">
          <h3 class="title">{{ title }}</h3>
        </a>
        <p *ngIf="!deviceService.isMobile()" class="excerpt">{{ excerpt }}</p>
        <span class="materials">{{ 'collections.text.items' | translate }} {{ collection.stats?.total }}</span>
        <ng-container *ngIf="!deviceService.isMobile()">
          <app-author-info [user]="_collection?.author"></app-author-info>
        </ng-container>
          <div class="tools-block">
            <ng-container *ngTemplateOutlet="menu"></ng-container>
          </div>
      </div>
    </div>

    <p class="description" [innerHTML]="description"></p>
    <ng-container *ngIf="deviceService.isMobile()">
      <app-author-info [user]="_collection?.author"></app-author-info>
    </ng-container>

    <div class="center-block" *ngIf="!isPrivate">
      <ng-template [ngIf]="canBuy || isAuthor">
        <div class="price-block">
          <div class="price-wrap">
            <span class="price">
              {{ getFormattedPrice(selectedLicensePrice) | async }}
            </span>
            <ng-template [ngIf]="discount">
              <span class="price-without-discounts">{{ getFormattedPrice(selectedLicensePrice, collection.discount) | async }}</span>
            </ng-template>
            <ng-template [ngIf]="discount && !deviceService.isMobile()">
              <div class="discount">
                {{'collections.text.discount' | translate: {'discount': discount} }}
              </div>
            </ng-template>
            <div class="icon-see-prices"
                 [appPopover]="pricesPopoverContent"
                 [popoverOnly]="true"
                 [position]="position">?
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="purchasedLicense">
        <div class="access-block">
          <div class="info-part">
            <app-icon class="access-icon" icon="key"></app-icon>
            <span class="type-access" [innerHtml]="'collections.text.license-type-label' | translate : {
            'label': ('<span class=\'access-type-text\'>' + (getLicenseName(purchasedLicense) | translate) + '</span>')
            }">
          </span>
          </div>
          <on-ui-button
            *ngIf="canUpgrade"
            class="primary outline"
            label="collections.actions.upgrade-license"
            (onclick)="showLicenseSelector()">
          </on-ui-button>
        </div>
      </ng-template>

      <div class="action-block">
        <ng-template [ngIf]="canBuy">
          <on-ui-button class="secondary"
                        label="collections.actions.buy"
                        (onclick)="showLicenseSelector()">
          </on-ui-button>
        </ng-template>
      </div>
    </div>

    <div *ngIf="showTypeFilters" class="tab-wrap">
      <on-ui-tabs [tabs]="typeFilters"></on-ui-tabs>
    </div>
  </article>
</ng-template>

<ng-template #coverBlock>
  <a [routerLink]="collectionUrl" class="cover-block">
    <ng-template [ngIf]="multiCoverUrls.length" [ngIfElse]="noCover">
      <div *ngFor="let coverItem of multiCoverUrls; let i = index; trackBy: trackByFn"
           class="cover-item"
           [ngClass]="coverCssClasses(multiCoverUrls.length, i)">
        <on-ui-cover [cover]="_coverItem(coverItem)"></on-ui-cover>
      </div>
    </ng-template>
    <ng-template #noCover>
      <on-ui-cover [cover]="_coverItem()"></on-ui-cover>
    </ng-template>
  </a>
</ng-template>

<app-modal *ngIf="!deviceService.isMobile() && buyCollectionModal"
           [schedule]="deviceService.isTablet()"
           (closed)="closeBuyCollectionModal()">
  <app-modal-body>
    <app-payment-checkout-wizard
      [content]="collection"
      [me]="me"
      (succeed)="loadCollection()"
      (closed)="closeBuyCollectionModal()">
    </app-payment-checkout-wizard>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="deviceService.isMobile() && buyCollectionModal"
                  [titleVisible]="false"
                  [withCloseButton]="true"
                  [customTitle]="'collections.text.license' | translate"
                  (closed)="closeBuyCollectionModal()">
  <app-mobile-modal-body>
    <app-payment-checkout-wizard
      [content]="collection"
      [me]="me"
      (succeed)="loadCollection()"
      (closed)="closeBuyCollectionModal()">
    </app-payment-checkout-wizard>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal *ngIf="!deviceService.isMobile() && paidContentModal"
           [canClose]="false"
           [canGoBack]="true"
           [prevNext]="true"
           [reachedPrev]="reachedPrev"
           [reachedNext]="reachedNext"
           (closed)="closePaidContentModal(true)"
           (togglePrev)="togglePrev($event)"
           (toggleNext)="toggleNext($event)">
  <app-modal-body>
    <div (click)="closePaidContentModal()" class="back-button">
      <span>{{ 'collections.back-to-collection' | translate }}</span>
    </div>
    <app-paid-content-informer (selectLicence)="showLicenseSelector()"></app-paid-content-informer>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="deviceService.isMobile() && paidContentModal"
                  [titleVisible]="false"
                  [withCloseButton]="true"
                  (closed)="closePaidContentModal()">
  <app-mobile-modal-body>
    <div class="wrap-content">
      <app-paid-content-informer (selectLicence)="showLicenseSelector()"></app-paid-content-informer>
    </div>
  </app-mobile-modal-body>
</app-mobile-modal>

<ng-template #pricesPopoverContent>
  <app-collection-license-prices [collection]="collection"></app-collection-license-prices>
</ng-template>

<pre *ngIf="debug$ | async">
isAuthor: {{ isAuthor | json }}
  isModerator: {{ isModerator | json }}
  canBuy: {{ canBuy | json }}
  canUpgrade: {{ canUpgrade | json }}
  purchasedLicense: {{ purchasedLicense | json }}
  betterLicense: {{ betterLicense | json }}
  selectedLicense: {{ selectedLicense | json }}
  visit: {{ collection.visit_info | json }}
</pre>

<app-alert type="error"
           *ngIf="isDeleteAlertOpened"
           (closed)="onToggleDeleteAlert()">
  <ng-container alert-title>{{ 'collections-constructor.delete-confirmation.title' | translate }}</ng-container>
  <ng-container alert-body>
    <div [innerHTML]="'collections-constructor.delete-confirmation.text' | translate"></div>
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="primary outline"
                  label="collections-constructor.delete-confirmation.cancel"
                  (onclick)="onToggleDeleteAlert()">
    </on-ui-button>
    <on-ui-button class="primary"
                  label="collections-constructor.delete-confirmation.delete"
                  (onclick)="onDeleteCollection()">
    </on-ui-button>
  </ng-container>
</app-alert>

<ng-template #menu>
  <div class="tools-box">
    <app-bookmark [item]="_collection" type="content"></app-bookmark>
    <on-ui-card-menu>
      <div *ngIf="!isAuthor" (click)="openComplainForm()" class="menu-item">{{ 'users.complain' | translate }}</div>
      <div *ngIf="isAuthor" class="menu-item"><a [routerLink]="editCollectionUrl"
                                                 class="menu-item">{{ 'collections.actions.menu-edit' | translate }}</a>
      </div>
      <div *ngIf="isAuthor" class="menu-item"><span class="menu-item"
                                                    (click)="onToggleDeleteAlert()">{{ 'collections.actions.menu-remove' | translate }}</span>
      </div>
      <div *ngIf="!isAuthor && isModerator" class="menu-item"><a class="menu-item warn"
                                                                 [routerLink]="editCollectionUrl">[⚠️]
        Edit</a></div>
      <div *ngIf="collection.purl" class="menu-item"><a class="menu-item warn" [href]="collection.purl">[⚠️] Panel</a>
      </div>
    </on-ui-card-menu>
  </div>
</ng-template>

<app-modal *ngIf="complainFormOpened && deviceService.isDesktop()"
           (closed)="closeComplainForm()"
           canClose="true"
           middle="true">
  <app-modal-body>
    <app-complaint-form [type]="'content'" (cancel)="closeComplainForm()"></app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="complainFormOpened && !deviceService.isDesktop()"
                  [titleVisible]="false"
                  (closed)="closeComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'content'" (cancel)="closeComplainForm()"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal *ngIf="deviceService.isDesktop() && showModal"
           [canClose]="false"
           [canGoBack]="true"
           [prevNext]="true"
           [reachedPrev]="reachedPrev"
           [reachedNext]="reachedNext"
           (closed)="onCloseModal($event, true)"
           (togglePrev)="togglePrev($event)"
           (toggleNext)="toggleNext($event)">
  <app-modal-body>
    <div (click)="onCloseModal($event)" class="back-button">
      <span>{{ 'collections.back-to-collection' | translate }}</span>
    </div>
    <app-content-card
      class="modal"
      [item_id]="item.id"
      [show]="openedCardIndex !== null"
      [showSkeleton]="false"
      [canClose]="false"
      [inline]="false"
      [active]="false"
      [fromCollection]="true"
      [meta]="true"
      (close)="onCloseCard()">
    </app-content-card>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && showModal" (closed)="onCloseModal($event)">
  <app-mobile-modal-title>{{ 'collections.collection' | translate }}</app-mobile-modal-title>

  <app-mobile-modal-body>
    <div class="card">
      <app-content-card [item_id]="item.id"
                        [show]="openedCardIndex !== null"
                        [showSkeleton]="false"
                        [canClose]="false"
                        [inline]="false"
                        [active]="false"
                        [displayMode]="'content_page'"
                        [fromCollection]="true"
                        [meta]="true"
                        (close)="onCloseCard()">
      </app-content-card>
    </div>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
